<!--
  @Description 测试用例
  @Date 2022-3-18
  @Author liufu
-->
<template>
  <div class="mainContainer cardProperty">
    <el-row>
      <el-col :span="24">
        <div class="buttonContainer">
          <div class="toolbar-dv">
            <toolBarBtn
              :parentData="this"
              :buttonVisible="buttonVisible"
              :moreButtonList="moreButtonList"
              ref="toolBarBtn"
            ></toolBarBtn>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <!-- 左 -->
      <el-col :span="19">
        <div
          :class="
            isFullScreenInTreeList ? 'fullScreen' : 'treeListTableContainer'
          "
          :style="{ height: treeListTableHeight }"
        >
          <YKDivider content-position="left">前置条件</YKDivider>
          <div
            :style="{
              height: '50px',
              overflow: 'auto',
              borderBottom: '1px solid #e8eaec',
            }"
          >
            &emsp;<span :style="{ fontSize: '14px' }">{{ form.todo8 }}</span>
          </div>
          <YKDivider content-position="left">用例步骤</YKDivider>
          <!-- <div
            :style="{
              position: 'fixed',
              top: '0',
              left: '0',
              zIndex: 99,
              width: '100%',
              height: '100%',
            }"
          > -->
          <vxe-table
            border
            ref="xTable"
            :show-overflow="false"
            :column-config="{ resizable: true }"
            :height="tableHeight"
            :tree-config="{
              transform: true,
              rowField: 'pid',
              parentField: 'parentId',
            }"
            :data="form.detailList"
          >
            <vxe-column type="seq" width="40px"></vxe-column>
            <vxe-column field="todo99" title="步骤" tree-node></vxe-column>
            <vxe-column field="todo98" title="预期"></vxe-column>
          </vxe-table>
          <!-- 缩放按钮 -->
          <div id="showZoom" @click="handleZoom('treeList')">
            <i v-if="!isFullScreenInTreeList" class="iconfont fjyk-zoomin"></i>
            <i v-else class="iconfont fjyk-windowing"></i>
          </div>
        </div>
        <!-- </div> -->
        <div
          :class="isFullScreenInHistory ? 'fullScreen' : 'historyInfoContainer'"
          :style="{ height: historyInfoHeight }"
        >
          <YKDivider content-position="left">历史记录</YKDivider>
          <div
            class="historyItemContainer"
            :style="{ height: historyItemHeight }"
          >
            <HistoryRecord :detailList="form.detailListHistory" />
          </div>
          <!-- 缩放按钮 -->
          <div id="showZoom" @click="handleZoom('history')">
            <i v-if="!isFullScreenInHistory" class="iconfont fjyk-zoomin"></i>
            <i v-else class="iconfont fjyk-windowing"></i>
          </div>
        </div>
      </el-col>
      <!-- 右 -->
      <el-col :span="5">
        <div class="mainFormContainer" :style="{ height: mainInfoHeight }">
          <YKDivider content-position="left">基本信息</YKDivider>
          <div
            :style="{
              width: '100%',
              marginTop: '10px',
              boxSizing: 'border-box',
              paddingLeft: '10px',
            }"
          >
            <el-descriptions
              :labelStyle="{
                minWidth: '70px',
                textAlign: 'right',
                color: '#838aaa',
              }"
              direction="horizontal"
              :column="1"
            >
              <el-descriptions-item
                v-for="(item, index) in descList"
                :key="index"
                :label="item.title"
              >
                <el-tag
                  v-if="['优先级', '用例状态'].includes(item.title)"
                  size="mini"
                  :type="colorPriorities(form[item.field])"
                >
                  {{ form[item.field] }}
                </el-tag>
                <span v-else>
                  {{ form[item.field] }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div v-if="form.detailListRelationBug.length > 0">
            <YKDivider content-position="left">相关Bug</YKDivider>
          </div>
          <div v-if="form.detailListAttachment.length > 0">
            <YKDivider content-position="left">附件</YKDivider>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <el-divider content-position="left">数据列表</el-divider> -->
    <!-- 角色选择框 -->
    <EmployeeSelect
      ref="EmployeeSelect"
      :isMultiple="false"
      @sureBackPerson="sureBackPerson"
    />
    <!-- 批量输入 -->
    <BatchInput ref="BatchInput" @sureHandler="sureBackBatch" />
    <!-- 编辑单据模态窗 -->
    <YKUseCaseEditModal ref="YKUseCaseEditModal" />
    <!-- 添加备注 -->
    <DetailAddMemoModal ref="DetailAddMemoModal" />
  </div>
</template>

<script>
import YKUseCaseEditModal from './YKUseCaseEditModal.vue'
import DetailAddMemoModal from './DetailAddMemoModal.vue'
export default {
  components: {
    YKUseCaseEditModal,
    DetailAddMemoModal
  },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            edit: false,
            see: false
          }
        }
      }
    },
    joinID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      id: 0,
      // 表单
      form: {
        productionType: '铁塔',
        productionVersion: '完整版',
        todo1: '人力资源',
        todo2: '员工档案',
        todo3: '紧急',
        todo4: '正常',
        todo5: '功能测试',
        todo6: '单元测试阶段',
        todo7: '无',
        todo8: '无',
        todo96: '2022-03-18 17:30:00',
        todo97: '刘福',
        lockDate: '',
        locker: '',
        lockerID: 0,
        writeDate: '',
        writer: '',
        writerID: 0,
        detailList: [
          {
            id: 0,
            pid: 1,
            parentId: -1,
            todo99: '新增单据',
            todo98: ''
          },
          {
            id: 1,
            pid: 0,
            parentId: 1,
            todo99: '1.1POST',
            todo98: `必填项验证：
              * 菜名
              * 数量`
          },
        ],
        detailListHistory: [
          {
            todo9: '2022-03-04 10:56:19',
            todo10: '刘福',
            todo11: '创建',
            todo12: `<span style="font-size: 20px"> 测试一下备注 </span>
            <img style="max-width: 100%;cursor: pointer;" onclick="window.open('http://192.168.103.29:12025/download/RequirementsGather/1647823915153_e3e053d64ce2966dfa9b748538c05d5f.png?md5=0rt14b41WjdZEPJpTDzXfA&expires=1647910328')" src='http://192.168.103.29:12025/download/RequirementsGather/1647823915153_e3e053d64ce2966dfa9b748538c05d5f.png?md5=0rt14b41WjdZEPJpTDzXfA&expires=1647910328' />`,
          },
          {
            todo9: '2022-03-04 10:56:19',
            todo10: '刘福',
            todo11: '添加备注',
            todo12: ``,
          },
        ],
        detailListAttachment: [],
        detailListRelationBug: []
      },
      // 校验规则
      rules: {
      },
      // 动态列
      tableColumns: [],
      bodyMenus: [],
      errIndex: [],
      // tabel工具栏
      tableToolbar: {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: true
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: true
          }
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      buttonVisible: {
        add: false,
        save: false,
        delete: false,
        update: false,
        refresh: false,
        search: false,
        sort: false,
        lock: false,
        unlock: false,
        more: false
      },
      moreButtonList: [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: true,
          event: 'save'
        },
        {
          name: '添加备注',
          icon: 'el-icon-edit-outline',
          disabled: true,
          event: 'addMemo'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: true,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: true,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: true,
          event: 'unlock'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: true,
          event: 'back'
        }
      ],
      ifAdd: false,
      // 是否绑定完成
      IfDataBindComplete: false,
      // 是否不能编辑
      dontEdit: true,
      THIS_HEIGHT_CONFIG: {
        headerHeight: 80,
        mainCardMaring: 15 * 2,
        mainCardPadding: 10 * 2,
        cardMarginOrPadding: 10,
        button: 40,
        elForm: 66 * 3,
        editorToolbar: 74,
        divider: this.$store.state.ykDivider
      },
      descList: [
        {
          title: '产品类型',
          field: 'productionType'
        },
        {
          title: '产品版本',
          field: 'productionVersion'
        },
        {
          title: '所属模块',
          field: 'todo1'
        },
        {
          title: '用例标题',
          field: 'todo2'
        },
        {
          title: '优先级',
          field: 'todo3'
        },
        {
          title: '用例状态',
          field: 'todo4'
        },
        {
          title: '用例类型',
          field: 'todo5'
        },
        {
          title: '适用阶段',
          field: 'todo6'
        },
        {
          title: '关键词',
          field: 'todo7'
        },
        {
          title: '创建者',
          field: 'todo97'
        },
        {
          title: '创建日期',
          field: 'todo96'
        },
      ],
      // 是否全屏显示
      isFullScreenInTreeList: false, // 用例步骤
      isFullScreenInHistory: false, // 历史记录
    }
  },
  created() {
    this.InitColumn()
    this.InitSetting()
    // this.BindComBox()
    this.id = this.joinID ? this.joinID : 0
    // this.BindText()
    this.InitRight() // 临时用一下
  },
  mounted() {
    // 临时- 展开所有树节点
    this.$nextTick(() => {
      this.$refs.xTable.setAllTreeExpand(true)
    })
  },
  methods: {
    addMemo() {
      this.$refs.DetailAddMemoModal.formVisible = true
    },
    handleZoom(type) {
      switch (type) {
        case 'treeList':
          this.isFullScreenInTreeList = !this.isFullScreenInTreeList
          break
        case 'history':
          this.isFullScreenInHistory = !this.isFullScreenInHistory
          break
      }
    },
    colorPriorities(num) {
      switch (num) {
        case '1':
        case '不通过':
        case '作废':
        case '紧急':
          return 'danger'
        case '2':
          return 'warning'
        case '通过':
        case '正常':
          return 'success'
        default:
          return 'primary'
      }
    },
    // 获取权限
    InitRight() {
      this.dontEdit = Boolean(this.form.writerID && this.form.writerID !== this.$store.state.userInfo.userId)
      this.tableToolbar = {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          }
        ]
      }
      this.moreButtonList = [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          event: 'save'
        },
        {
          name: '添加备注',
          icon: 'el-icon-edit-outline',
          disabled: false,
          event: 'addMemo'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: this.id === 0 || !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: !this.id || !this.Authority.edit || this.form.lockerID > 0,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: !this.id || !this.Authority.edit || this.form.lockerID <= 0,
          event: 'unlock'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: false,
          event: 'back'
        }
      ]
      this.InitColumn()
    },
    // 导入excel
    importExcel() {
      this.$refs.ExcelImport.isShow = true
    },
    // 返回excel
    sureImportBack(List) {
      if (List.length > 0) {
        for (let item of List) {
          this.$refs.xTable.insertAt(item)
        }
        this.IfExistModify = true
      }
    },
    // 批量输入返回
    sureBackBatch(str) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = str
            }
          }
        }
      })
    },
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 编辑
    edit() {
      this.$refs.YKUseCaseEditModal.formVisible = true
    },
    // 新增
    async add() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      form.detailList = insertRecords
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.post('/Common/BMenuGroup/both', form)
      if (res.isSuccess) {
        this.id = res.data
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.ifAdd = true
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.put('/Common/BMenuGroup/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 锁定
    async lock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/lock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('锁定成功！')
      this.BindText()
    },
    // 解锁
    async unlock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/unlock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('解锁成功！')
      this.BindText()
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      // 重复行
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['groupName', 'vuePath'])
      if (this.errIndex.length > 0) {
        flag = false
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 获取数据
    async BindText() {
      this.IfDataBindComplete = false
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Common/BMenuGroup/both', {
          params: {
            id: this.id
          }
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.form = res.data
        this.changeType(res.data.productionType, true)
      } else {
        this.form = {
          productionType: '',
          productionVersion: '',
          todo1: '',
          todo2: '',
          todo3: '',
          todo4: '',
          todo5: '',
          todo6: '',
          todo7: '',
          todo8: '',
          detailList: []
        }
      }
      this.InitRight()
      this.$nextTick(() => {
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // table 点击删除列
    delete() {
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.sureDelete()
        })
        .catch(() => { })
    },
    async sureDelete() {
      const that = this
      const { data: res } = await that.$http.delete(
        '/Common/BMenuGroup', {
        data: {
          id: that.id,
          effectCondition: that.Authority.alEffectCondition,
          empower: []
        }
      })
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        that.IfExistModify = false
        that.back('del')
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    back(type) {
      if (this.IfExistModify) {
        this.$confirm('您已做出修改，是否关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if (this.ifAdd) {
              this.$emit('SingleBack', -1)
            } else {
              switch (type) {
                case 'del':
                  this.$emit('SingleBack', -1)
                  break
                default:
                  this.$emit('SingleBack', this.id)
                  break
              }
            }
          })
          .catch(() => {
          })
      } else {
        if (this.ifAdd) {
          this.$emit('SingleBack', -1)
        } else {
          switch (type) {
            case 'del':
              this.$emit('SingleBack', -1)
              break
            default:
              this.$emit('SingleBack', this.id)
              break
          }
        }
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
    },
    // 初始化界面
    InitSetting() {
      // 是否可添加行
      // this.tableToolbar = {
      //   buttons: [
      //     {
      //       code: 'insertOne',
      //       name: '新增1行',
      //       disabled: !this.Authority.edit
      //     },
      //     {
      //       code: 'insertTen',
      //       name: '新增10行',
      //       disabled: !this.Authority.edit
      //     }
      //   ]
      // }
    },
    // 返回人员
    sureBackPerson(obj) {
      if (obj && obj.name) {
        this.areas.forEach(area => {
          for (let row of area.rows) {
            for (let col of area.cols) {
              if (col.property === this.colProperty) {
                row[this.colProperty] = obj.name
              }
            }
          }
        })
      }
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.productionVersion = []
      this.ComBoxItems.productionType = []
      const { data: selectRes } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.ComBoxItems.productionType.push(item)
              break
          }
        }
      }
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        // {
        //   type: 'seq',
        //   width: '50',
        //   className: 'seqErrorVaildClass',
        //   slots: {
        //     default: ({ row }) => {
        //       if (row.ifRepeat) {
        //         return [<el-tooltip class="tooltipItem"
        //           effect="light" content={row.repeatText} placement="right" >
        //           <div style="width: 100%; height: 100%">
        //             <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
        //           </div>
        //         </el-tooltip>]
        //       } else {
        //         return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
        //       }
        //     }
        //   }
        // },
        // { field: 'delete', title: '删除', visible: this.Authority.edit && !this.dontEdit && !this.form.lockerID, width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.removeRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } } }
      ]
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod({ column }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.form.lockerID > 0 || this.dontEdit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.form.lockerID > 0 || this.dontEdit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 快捷键
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.Authority.edit
          if (!column) {
            item.visible = false
          } else if ((item.code === 'pickMan' || item.code === 'clear' || item.code === 'setNull') &&
            (column.property === 'frontEngineer' || column.property === 'backEngineer'
              || column.property === 'techTester' || column.property === 'businessTester')) {
            item.visible = true
          } else if (item.code === 'batchInput' && column.property === 'groupName') {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    async contextMenuClickEvent({ menu }) {
      switch (menu.code) {
        case 'pickMan':
          this.$refs.EmployeeSelect.formVisible = true
          break
        case 'clear':
        case 'setNull':
          this.areas.forEach(area => {
            for (let row of area.rows) {
              for (let col of area.cols) {
                if (col.property === this.colProperty) {
                  menu.code === 'clear'
                    ? row[this.colProperty] = ''
                    : row[this.colProperty] = '/'
                }
              }
            }
          })
          break
        case 'batchInput':
          this.$refs.BatchInput.formVisible = true
          break
      }
    },
    // table工具栏方法
    toolbarButtonClickEvent({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent() {
      let record = {}
      this.$refs.xTable.insertAt(record, -1)
      this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent() {
      let record = {}
      for (var i = 0; i < 10; i++) {
        this.$refs.xTable.insertAt(record, -1)
      }
      this.IfExistModify = true
    },
    // 当类型改变
    async changeType(type, isInit = false) {
      this.ComBoxItems.productionVersion = []
      if (!type || type === '') {
        this.form.productionVersion = ''
        return
      }
      const { data: res } = await this.$http.post(`/Common/ProductVersionSet/list?sqlTitle=${type}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data) {
        this.ComBoxItems.productionVersion.push({
          name: item.productionVersion,
          value: item.productionVersion
        })
      }
      const option = this.ComBoxItems.productionVersion.filter(item => {
        return item.value === this.form.productionVersion
      })
      if (!isInit && option.length <= 0) {
        this.form.productionVersion = ''
      }
    },
  },
  computed: {
    treeListTableHeight() {
      if (this.isFullScreenInTreeList) {
        return '100vh'
      } else {
        return ((Number(this.$store.state.clientHeight) -
          this.THIS_HEIGHT_CONFIG.headerHeight - this.THIS_HEIGHT_CONFIG.mainCardPadding -
          this.THIS_HEIGHT_CONFIG.mainCardMaring - this.THIS_HEIGHT_CONFIG.button -
          (this.THIS_HEIGHT_CONFIG.cardMarginOrPadding * 2)) * 0.6) + 'px'
      }
    },
    tableHeight() {
      if (this.isFullScreenInTreeList) {
        const todo8Height = 51
        const paddingHeightInCard = 10 * 2
        return (Number(this.$store.state.clientHeight) - this.THIS_HEIGHT_CONFIG.divider * 2 - todo8Height - paddingHeightInCard) + 'px'
      } else {
        const todo8Height = 51
        const paddingHeightInCard = 10 * 2
        return (((Number(this.$store.state.clientHeight) -
          this.THIS_HEIGHT_CONFIG.headerHeight - this.THIS_HEIGHT_CONFIG.mainCardPadding -
          this.THIS_HEIGHT_CONFIG.mainCardMaring - this.THIS_HEIGHT_CONFIG.button -
          (this.THIS_HEIGHT_CONFIG.cardMarginOrPadding * 2)) * 0.6) - this.THIS_HEIGHT_CONFIG.divider * 2 - todo8Height - paddingHeightInCard) + 'px'
      }
      // return Number(this.$store.state.clientHeight) + 'px'
    },
    historyInfoHeight() {
      if (this.isFullScreenInHistory) {
        return '100vh'
      } else {
        return ((Number(this.$store.state.clientHeight) -
          this.THIS_HEIGHT_CONFIG.headerHeight - this.THIS_HEIGHT_CONFIG.mainCardPadding -
          this.THIS_HEIGHT_CONFIG.mainCardMaring - this.THIS_HEIGHT_CONFIG.button -
          (this.THIS_HEIGHT_CONFIG.cardMarginOrPadding * 2)) * 0.4) + 'px'
      }
    },
    historyItemHeight() {
      const paddingHeightInCard = 10 * 2
      const dividerLineInCard = 33
      return (((Number(this.$store.state.clientHeight) -
        this.THIS_HEIGHT_CONFIG.headerHeight - this.THIS_HEIGHT_CONFIG.mainCardPadding -
        this.THIS_HEIGHT_CONFIG.mainCardMaring - this.THIS_HEIGHT_CONFIG.button -
        (this.THIS_HEIGHT_CONFIG.cardMarginOrPadding * 2)) * 0.4) - dividerLineInCard - paddingHeightInCard) + 'px'
    },
    mainInfoHeight() {
      return (Number(this.$store.state.clientHeight) -
        this.THIS_HEIGHT_CONFIG.headerHeight - this.THIS_HEIGHT_CONFIG.mainCardPadding -
        this.THIS_HEIGHT_CONFIG.mainCardMaring - this.THIS_HEIGHT_CONFIG.button -
        this.THIS_HEIGHT_CONFIG.cardMarginOrPadding) + 'px'
    },
  },
  watch: {
    form: {
      handler() {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@card-margin: 15px;
@card-padding: 10px;
.mainContainer {
  box-sizing: border-box;
  margin: @card-margin;
  padding: @card-padding;
  height: calc(100vh - @header-height - (@card-margin * 2));
  overflow: auto !important;
  border-radius: 10px;
  box-shadow: #bebebe 2px 2px 10px;
}
.cardProperty {
  // margin: 10px;
  box-shadow: #bebebe 2px 2px 5px;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px;
}
.buttonContainer {
  width: 100%;
  // display: flex;
  // justify-content: center;
}
.treeListTableContainer {
  position: relative;

  // background-color: rgb(129, 34, 34);
  width: calc(100% - 10px);
  margin: 10px 10px 0 0;
  .cardProperty;
  overflow: auto;
}
.historyInfoContainer {
  position: relative;

  // background-color: rgb(41, 67, 138);
  width: calc(100% - 10px);
  margin: 10px 10px 0 0;
  .cardProperty;
  .historyItemContainer {
    overflow: auto;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    #historyItems {
      color: #3c4353;
      font-size: 14px;
      margin-bottom: 5px;
      div {
        width: calc(100% - 10px);
      }
    }
  }
}
.mainFormContainer {
  // background-color: red;
  width: 100%;
  margin: 10px 0 0 0;
  .cardProperty;
  overflow: auto;
}

// 全屏
.fullScreen {
  position: fixed;
  box-sizing: border-box;
  padding: 10px;
  top: 0px;
  left: 0px;
  width: 100vw;
  overflow: auto;
  background-color: #fff;
  z-index: 999;
}

// 缩放按钮
#showZoom {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  .iconfont.fjyk-zoomin {
    color: #666666;
    font-size: 16px;
    transition: all 0.1s;
  }
  .iconfont.fjyk-windowing {
    color: #666666;
    font-size: 20px;
    transition: all 0.1s;
  }
}

#showZoom:hover {
  .iconfont.fjyk-zoomin {
    color: #434957;
    font-size: 20px;
    transition: all 0.1s;
  }
  .iconfont.fjyk-windowing {
    color: #434957;
    font-size: 16px;
    transition: all 0.1s;
  }
}

/** ************* 滚动条整体样式 ************** **/
::-webkit-scrollbar {
  width: 9px; /*高宽分别对应横竖滚动条的尺寸*/
  height: auto;
}

/*查找面板的滚动条里面小方块*/
::-webkit-scrollbar-thumb {
  /* border-radius: 10px; */
  background-color: skyblue;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}

/*查找面板的滚动条里面轨道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: #ededed;
  /* border-radius: 10px; */
}
</style>
